import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const ItemSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background-color: ${COLORS.bgWhite};
`

export const ItemSectionHeading = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.18px;
  color: ${COLORS.textPrimary};
`

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ItemImage = styled.img`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
`

export const ItemTitle = styled.span`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`

export const ItemQuantity = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`
